import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ShoppingBag } from "lucide-react";
import LionLogo from "./LionLogo";
import { useCart } from "../context/CartContext";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/shop", label: "Shop" },
  { to: "/book-reading", label: "Book a Reading" },
  { to: "/house-calls", label: "House Calls" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/knowledge", label: "Knowledge" },
  { to: "/social-hub", label: "Social Hub" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { count, setDrawerOpen } = useCart();

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/10"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo-link">
          <LionLogo size={44} />
          <div className="leading-tight">
            <div className="font-serif text-lg tracking-tight text-[#FFFFF0]">Lyon's Den</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">Protection · LLC</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className={({ isActive }) =>
                `text-xs uppercase tracking-[0.18em] transition-colors ${
                  isActive ? "text-[#D4AF37]" : "text-white/70 hover:text-white"
                }`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => setDrawerOpen(true)}
            className="relative p-2 text-white/80 hover:text-[#D4AF37] transition-colors"
            data-testid="header-cart-btn"
            aria-label={`Open cart with ${count} items`}
          >
            <ShoppingBag size={20} />
            {count > 0 && (
              <span
                className="absolute -top-0.5 -right-0.5 bg-[#D4AF37] text-black text-[10px] font-bold rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center"
                data-testid="header-cart-count"
              >
                {count}
              </span>
            )}
          </button>
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-black/95" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                className={({ isActive }) =>
                  `py-2 text-sm uppercase tracking-[0.2em] border-b border-white/5 ${
                    isActive ? "text-[#D4AF37]" : "text-white/80"
                  }`
                }
                end={n.to === "/"}
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
